export default "__VITE_ASSET__DZfgn3yS__"